import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "@cart-client/analytics/constants";
import { useCallback, useContext } from "react";
import { AnalyticsContext } from "@swiggy-private/checkout-core";
import { CartContext } from "@cart-client/contexts/CartContext";
import { getCartId } from "@cart-client/helpers/Cart";

export const useBillDetailsBannerAnalytics = () => {
    const { cartState } = useContext(CartContext);
    const { reviewedCart: cartResponse } = cartState;
    const { impressionEvent, clickEvent } = useContext(AnalyticsContext);
    const cartId = getCartId(cartResponse);

    const onImpressionBanner = useCallback(
        (bannerType?: string) => {
            impressionEvent({
                category: SCREEN_NAME.CHECKOUT,
                action: IMPRESSION_ACTIONS.IMPRESSION_BILL_DETAILS_BANNER,
                context: JSON.stringify({ cartId, bannerType }),
            });
        },
        [cartId, impressionEvent],
    );

    const onClickBanner = useCallback(
        (bannerType?: string) => {
            clickEvent({
                category: SCREEN_NAME.CHECKOUT,
                action: CLICK_ACTIONS.CLICK_BILL_DETAILS_BANNER,
                context: JSON.stringify({ cartId, bannerType }),
            });
        },
        [cartId, clickEvent],
    );

    const onImpressionBannerHalfcard = useCallback(
        (bannerType?: string) => {
            impressionEvent({
                category: SCREEN_NAME.CHECKOUT,
                action: IMPRESSION_ACTIONS.IMPRESSION_BILL_DETAILS_BANNER_HALF_CARD,
                context: JSON.stringify({ cartId, bannerType }),
            });
        },
        [cartId, impressionEvent],
    );

    const onClickCloseBannerHalfcard = useCallback(
        (bannerType?: string) => {
            clickEvent({
                category: SCREEN_NAME.CHECKOUT,
                action: CLICK_ACTIONS.CLICK_BILL_DETAILS_BANNER_HALF_CARD,
                context: JSON.stringify({ cartId, bannerType }),
            });
        },
        [cartId, clickEvent],
    );

    return {
        onImpressionBanner,
        onClickBanner,
        onImpressionBannerHalfcard,
        onClickCloseBannerHalfcard,
    };
};
